module.exports = __webpack_public_path__ + "img/close-white.0dcdbf11.svg";